import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AppRouteEnum } from '../../routes/routeEnums';

// Import menu icons
import assetsActive from '../../assets/images/bottom-menu/assets-active.svg';
import assets from '../../assets/images/bottom-menu/assets.svg';
import orderActive from '../../assets/images/bottom-menu/order-active.svg';
import order from '../../assets/images/bottom-menu/order.svg';
import historyActive from '../../assets/images/bottom-menu/history-active.svg';
import history from '../../assets/images/bottom-menu/history.svg';
import menuActive from '../../assets/images/bottom-menu/menu-active.svg';
import menu from '../../assets/images/bottom-menu/menu.svg';
import statementActive from '../../assets/images/bottom-menu/statement-active.svg';
import statement from '../../assets/images/bottom-menu/statement.svg';

interface MenuItem {
  icon: string;
  activeIcon: string;
  label: string;
  path: AppRouteEnum;
}

const menuItems: MenuItem[] = [
  {
    icon: assets,
    activeIcon: assetsActive,
    label: 'Tài sản',
    path: AppRouteEnum.ASSETS,
  },
  {
    icon: statement,
    activeIcon: statementActive,
    label: 'Danh mục',
    path: AppRouteEnum.PORTFOLIO,
  },
  {
    icon: order,
    activeIcon: orderActive,
    label: 'Đặt lệnh\n& Sổ lệnh',
    path: AppRouteEnum.ORDER,
  },
  {
    icon: history,
    activeIcon: historyActive,
    label: 'Sao kê',
    path: AppRouteEnum.STATEMENT,
  },
  {
    icon: menu,
    activeIcon: menuActive,
    label: 'Menu',
    path: AppRouteEnum.MENU,
  },
];

const ACTIVE_TAB_KEY = 'vftrade-active-tab';

/** Sibling statement pages that should keep the Sao kê tab active. */
const STATEMENT_TAB_PATHS: AppRouteEnum[] = [
  AppRouteEnum.STATEMENT,
  AppRouteEnum.STOCK_STATEMENT,
  AppRouteEnum.WINLOSS_STATEMENT,
  AppRouteEnum.PORTFOLIO_STATEMENT,
  AppRouteEnum.MONEY_STATEMENT,
];

const isMatchingPath = (pathname: string, path: AppRouteEnum): boolean => {
  return pathname === path || pathname.startsWith(`${path}/`);
};

const BottomMenu: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isPathActive = (path: AppRouteEnum): boolean => {
    if (path === AppRouteEnum.STATEMENT) {
      return STATEMENT_TAB_PATHS.some((statementPath) =>
        isMatchingPath(location.pathname, statementPath)
      );
    }

    return isMatchingPath(location.pathname, path);
  };

  // Store active tab when navigating
  const handleNavigate = (path: AppRouteEnum) => {
    // Save the active tab to localStorage
    localStorage.setItem(ACTIVE_TAB_KEY, path);
    
    if (!isPathActive(path)) {
      // Clear history and navigate to new path
      window.history.replaceState(null, '', path);
      navigate(path, { replace: true });
    }
  };

  return (
    <div className="bg-white border-t border-[#E7ECF3] h-[80px] flex items-center justify-between px-6 text-[12px] pb-4 w-full">
      {menuItems.map((item) => {
        // Check if this tab is currently active
        const isActive = isPathActive(item.path);
        return (
          <button
            key={item.path}
            onClick={() => handleNavigate(item.path)}
            className="flex flex-col items-center gap-1"
          >
            <div className="h-6 flex items-center justify-center">
              <img
                src={isActive ? item.activeIcon : item.icon}
                alt={item.label}
                className="w-6 h-6"
              />
            </div>
            <div className="h-[28px] flex items-start justify-center">
              <span
                className={`text-xs whitespace-pre-line text-center leading-[14px] ${
                  isActive ? 'text-[#5A4099]' : 'text-[#808191]'
                }`}
              >
                {item.label}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default BottomMenu;
